<template>
<div>
    <section class="section-border border-primary">
        <div class="container d-flex flex-column">
            <div class="row align-items-center justify-content-center gx-0 min-vh-100">
                <div class="col-8 col-md-6 col-lg-7 offset-md-1 order-md-2 mt-auto mt-md-0 pt-12 pb-4 py-md-11">
                    <img src="/assets/img/illustrations/illustration-8.png" alt="..." class="img-fluid">
                </div>
                <div class="col-12 col-md-5 col-lg-4 order-md-1 mb-auto mb-md-0 pb-8 py-md-11">
                    <h1 class="mb-0 fw-bold text-center">Registration</h1>
                    <p class="mb-4 text-center text-muted" v-if="Object.keys(errors).length < 1">
                        Register to get access to the API token
                    </p>
                    <p class="mb-6 text-center text-success fw-bold">
                        <i class="fe fe-gift me-2"></i>{{ $state.context.free_requests }} free requests trial after Telegram verification
                    </p>

                    <p class="mb-6 text-center text-danger" v-for="error in errors.__all__" :key="error">{{ error }}</p>
                    <form class="mb-6" @submit.prevent="register">
                        <div class="form-group">
                            <label class="form-label" for="email">Email</label>
                            <input type="email" class="form-control" :class="{'is-invalid': errors.email}" id="email" placeholder="Enter your Email" v-model="form.email">
                            <small class="form-text text-danger" v-for="error in errors.email" :key="error">{{ error }}</small>
                        </div>
                        <div class="form-group mb-5">
                            <label class="form-label" for="password">Password</label>
                            <input type="password" class="form-control" :class="{'is-invalid': errors.password}" id="password" placeholder="Enter your password" v-model="form.password">
                            <small class="form-text text-danger" v-for="error in errors.password" :key="error">{{ error }}</small>
                        </div>
                        <div class="form-group mb-5">
                            <label class="form-label" for="password2">Repeat password</label>
                            <input type="password" class="form-control" :class="{'is-invalid': errors.password2}" id="password2" placeholder="Enter your password again" v-model="form.password2">
                            <small class="form-text text-danger" v-for="error in errors.password2" :key="error">{{ error }}</small>
                        </div>
			<!-- Turnstile widget -->
                        <div class="cf-turnstile" v-if="showTurnstile" style="min-height: 65px"></div>
                        <div class="form-group mb-5 fs-sm">
                            <label class="d-block" :class="{'is-invalid': errors.agree_terms_of_service}">
                                <input type="checkbox" class="form-check-input" v-model="form.agree_terms_of_service">
                                I accept the
                                <a href="/help/terms-of-service">Terms of service</a>
                            </label>
                            <label class="d-block" :class="{'is-invalid': errors.agree_privacy_policy}">
                                <input type="checkbox" class="form-check-input" v-model="form.agree_privacy_policy">
                                I accept the
                                <a href="/help/privacy-policy">Privacy Policy</a>
                            </label>
                        </div>
                        <button class="btn w-100 btn-primary" type="submit" :disabled="disabled">Register</button>
                    </form>
                    <div class="d-flex align-items-center my-4">
                        <hr class="flex-grow-1"><span class="mx-3 text-muted small">or</span><hr class="flex-grow-1">
                    </div>
                    <div class="text-center mb-4" ref="tgLoginWidget"></div>
                    <p class="mb-0 fs-sm text-center text-muted">
                        Already have an account?
                        <router-link :to="{path: '/login', query: safeNextRaw ? {next: safeNextRaw} : {}}">Then login</router-link>.
                    </p>
                </div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import { EventBus } from "@/bus";
import { displayErrors } from "utils/string"
import { safeNext, navigateToNext } from "utils/redirect"
import { tgLoginMixin } from "utils/tg-login"
export default {
    mixins: [tgLoginMixin],
    data() {
        return {
            form: {
                agree_terms_of_service: true,
                agree_privacy_policy: true,
                cf_turnstile_response: ''
            },
            errors: {},
            disabled: false
        }
    },
    computed: {
        showTurnstile() {
            return env.DEBUG !== 'True' && this.$state.cfSiteKey && typeof this.$state.cfSiteKey === 'string';
        },
        safeNextRaw() {
            return safeNext(this.$route.query.next)
        }
    },
    created() {
        EventBus.on('context:loaded', context => {
            if (!context.id) return
            const next = this.safeNextRaw
            if (!next) {
                this.$router.replace({path: '/dashboard'})
                return
            }
            navigateToNext(this.$services, next).catch(resp => {
                displayErrors(resp, this)
                this.disabled = false
            })
        })
        EventBus.emit('context:request')
    },
    mounted() {
        if (env.DEBUG !== 'True') {
            setTimeout(() => {
                this.initializeTurnstile();
            }, 1000);
            window.onTurnstileSuccess = this.onTurnstileSuccess.bind(this);
        }
    },
    methods: {
        initializeTurnstile() {
            if (env.DEBUG === 'True') return;
            const element = document.querySelector(".cf-turnstile");
            if (!element) {
                console.error("Turnstile element not found.");
                return;
            }
            if (!this.$state.cfSiteKey || typeof this.$state.cfSiteKey !== 'string') {
                console.error("Turnstile sitekey not configured.");
                return;
            }
            window.turnstile.render(element, {
                sitekey: this.$state.cfSiteKey,
                theme: 'dark',
                callback: this.onTurnstileSuccess,
            });
        },
        onTurnstileSuccess(token) {
           this.form.cf_turnstile_response = token;
        },
        register() {
            if (!this.form.cf_turnstile_response && env.DEBUG === 'False') {
               alert("CloudFlare check has failed!\nVerify you are human, please.");
               return;
            }
            this.disabled = true
            this.errors = {}
            if (this.$state.context.promocode) {
                this.form.promocode = this.$state.context.promocode;
                this.form.referrer = this.$state.context.referrer;
            } else {
                this.form.promocode = localStorage.getItem("promocode");
                this.form.referrer = localStorage.getItem("referrer");
            }
            this.$services.Register().save(this.form).then(resp => {
                this.errors = {}
                if (resp.body.state) {
                    EventBus.emit('context:changed')
                    setTimeout(() => {
                        const next = this.safeNextRaw
                        if (!next) {
                            this.$router.replace({path: '/tokens'})
                            return
                        }
                        navigateToNext(this.$services, next).catch(err => {
                            displayErrors(err, this)
                            this.disabled = false
                        })
                    })
                }
                displayErrors(resp, this);
                this.disabled = false
            }).catch(resp => {
                displayErrors(resp, this);
                this.disabled = false
            })
            setTimeout(() => {
                this.disabled = false
            }, 10000)
        }
    }
}
</script>
<style scoped>
label.is-invalid { color: red }
.is-invalid a { color: brown }
</style>
